import React from "react"

const IconDark = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
      >
         <path d="M22 12c0 5.514-4.486 10-10 10-4.826 0-8.864-3.436-9.797-7.99 3.573.142 6.903-1.818 8.644-5.013 1.202-2.206 1.473-4.679.83-6.992C17.285 1.811 22 6.343 22 12zM12 0c-1.109 0-2.178.162-3.197.444C12.629 6.377 6.777 13.94.022 11.572L0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0z"></path>
      </svg>
   )
}

export { IconDark as default }
